<div class="container">
  <app-header></app-header>
  <app-auth-container [authenticationRequired]="authenticationRequired">
    <ng-content></ng-content>
  </app-auth-container>
  <app-footer></app-footer>
</div>
